export default {
      id: "arrow-play-usage",
      viewBox: "0 0 8 10",
      url: __webpack_public_path__ + "sprite.svg#arrow-play",
      toString: function () {
        return this.url;
      }
    }